
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","fill":"#4D4D4D"}},[_c('path',{attrs:{"d":"M.934 5.614c.345 0 .625.28.625.625v4.273c0 .792.644 1.44 1.44 1.44h10.129c.791 0 1.44-.644 1.44-1.44V6.31a.625.625 0 111.25 0v4.202c0 1.49-1.211 2.69-2.69 2.69H2.998a2.692 2.692 0 01-2.69-2.69V6.239c0-.345.28-.625.625-.625z"}}),_c('path',{attrs:{"d":"M7.963.797c.345 0 .625.28.625.625v7.53a.625.625 0 11-1.25 0v-7.53c0-.345.28-.625.625-.625z"}}),_c('path',{attrs:{"d":"M10.597 6.544a.625.625 0 010 .884L8.772 9.252a1.14 1.14 0 01-1.607 0L5.418 7.506a.625.625 0 01.884-.884l1.666 1.666 1.745-1.744a.625.625 0 01.884 0z"}})])])
          )
        }
      }
    